// Zajednička logika za izvoz u Excel. Nazivi stupaca/listova se prevode preko betonLang.
import { betonT } from './betonLang'

// BrojNarudzbeDisp i NazivGotovogProizvoda su spremljeni u FreeS2 kao JSON
function citajExtra (b) {
  try {
    return b && b.FreeS2 ? JSON.parse(b.FreeS2) : {}
  } catch (e) {
    return {}
  }
}

// spoji datum i vrijeme u jedan string (Mixing completion time)
function spojiVrijeme (b, dateFn) {
  const d = dateFn ? dateFn(b.Datum) : (b.Datum || '').substr(0, 10)
  const t = b.Vrijeme ? b.Vrijeme.substr(0, 5) : ''
  return (d + ' ' + t).trim()
}

// sortiraj: prvo po betonari (Objekat), pa po datumu uzlazno (najstariji prvi)
function sortByPlantDate (betoni) {
  return betoni.slice().sort((a, b) => {
    const pa = String(a.Objekat || '')
    const pb = String(b.Objekat || '')
    if (pa !== pb) return pa.localeCompare(pb)
    return new Date(a.Datum) - new Date(b.Datum)
  })
}

// kolone za sheet "Delivery note(s)" (prikaz kupca, količine itd.)
export function otpremniceColumns (lang) {
  const t = betonT(lang)
  return [
    { label: t.deliveryNote, value: 'brojotpremnice' },
    { label: t.quantityM3, value: 'kolicina' },
    { label: t.customer, value: 'kupac' },
    { label: t.constructionSite, value: 'gradiliste' },
    { label: t.driver, value: 'vozac' },
    { label: t.regPlate, value: 'regOzn' },
    { label: t.recipe, value: 'receptura' },
    { label: t.recipeCode, value: 'sifraArtikla' },
    { label: t.mixingTime, value: 'mixingTime' },
    { label: t.cancelled, value: 'storno' }
  ]
}

export function otpremniceRows (betoni, dateFn, lang) {
  if (!betoni || !betoni.length) return []
  const t = betonT(lang)
  return sortByPlantDate(betoni).map(b => ({
    kupac: b.Kupac,
    brojotpremnice: parseInt(b.BrojOtpremnice),
    kolicina: parseFloat(b.Kolicina) || 0,
    gradiliste: b.Gradiliste,
    vozac: b.Vozac,
    regOzn: b.RegOzn,
    receptura: b.Receptura,
    sifraArtikla: b.SifraArtikla,
    mixingTime: spojiVrijeme(b, dateFn),
    storno: b.Storno ? t.cancelledValue : ''
  }))
}

// --- Material consumption: ŠIROKI format (1 otpremnica = 1 red) ---
// stableKey (Agg/Cem/Add) = ključ u redu/koloni; dataPrefix (Agr/Cem/Adi) = čitanje iz betona
const GRUPE = [
  { stableKey: 'Agg', dataPrefix: 'Agr', count: 8, labelKey: 'aggPrefix' },
  { stableKey: 'Cem', dataPrefix: 'Cem', count: 6, labelKey: 'cemPrefix' },
  { stableKey: 'Add', dataPrefix: 'Adi', count: 6, labelKey: 'addPrefix' }
]

function komponentaKolone (g, t) {
  const cols = []
  const p = t[g.labelKey]
  for (let i = 1; i <= g.count; i++) {
    cols.push({ label: `${p}${i}_${t.cName}`, value: `${g.stableKey}${i}_name` })
    cols.push({ label: `${p}${i}_${t.cCode}`, value: `${g.stableKey}${i}_code` })
    cols.push({ label: `${p}${i}_${t.cTarget}`, value: `${g.stableKey}${i}_target` })
    cols.push({ label: `${p}${i}_${t.cDosed}`, value: `${g.stableKey}${i}_dosed` })
  }
  return cols
}

function komponentaURed (row, beton, g) {
  for (let i = 1; i <= g.count; i++) {
    row[`${g.stableKey}${i}_name`] = beton[`${g.dataPrefix}${i}NazivArtikla`] || ''
    row[`${g.stableKey}${i}_code`] = beton[`${g.dataPrefix}${i}SifraArtikla`] || ''
    row[`${g.stableKey}${i}_target`] = parseFloat(beton[`${g.dataPrefix}${i}Zadano`]) || 0
    row[`${g.stableKey}${i}_dosed`] = parseFloat(beton[`${g.dataPrefix}${i}Dozirano`]) || 0
  }
}

// kolone za Excel sheet "Material consumption" (široki format)
export function utrosciColumns (lang) {
  const t = betonT(lang)
  const cols = [
    { label: t.deliveryNote, value: 'otpremnica' },
    { label: t.order, value: 'nalog' },
    { label: t.erpMainOrder, value: 'erpMainOrder' },
    { label: t.mixingTime, value: 'mixingTime' },
    { label: t.companyName, value: 'tvrtka' },
    { label: t.plantName, value: 'objekat' },
    { label: t.customer, value: 'kupac' },
    { label: t.constructionSite, value: 'gradiliste' },
    { label: t.recipe, value: 'receptura' },
    { label: t.recipeCode, value: 'sifraArtikla' },
    { label: t.nameFinishedProduct, value: 'nameFinishedProduct' },
    { label: t.quantityM3, value: 'kolicina' },
    { label: t.returnedConcrete, value: 'povratBetona' },
    { label: t.driver, value: 'vozac' },
    { label: t.regPlate, value: 'regOzn' },
    { label: t.cancelled, value: 'storno' }
  ]
  GRUPE.forEach(g => cols.push(...komponentaKolone(g, t)))
  cols.push(
    { label: `${t.water}_${t.wTarget}`, value: 'water_target' },
    { label: `${t.water}_${t.wDosed}`, value: 'water_dosed' },
    { label: `${t.water}_${t.wAdded}`, value: 'water_added' },
    { label: `${t.water}_${t.wCorrection}`, value: 'water_correction' }
  )
  return cols
}

// pretvori listu otpremnica u redove - JEDNA otpremnica = JEDAN red
export function utrosciRows (betoni, dateFn, lang) {
  if (!betoni || !betoni.length) return []
  const t = betonT(lang)
  return sortByPlantDate(betoni).map(beton => {
    const god = dateFn ? dateFn(beton.Datum).slice(-4) : String(beton.Datum || '').substr(0, 4)
    const extra = citajExtra(beton)
    const row = {
      otpremnica: `${beton.ObjekatID}_${parseInt(beton.BrojOtpremnice)}_${god}`,
      nalog: `${beton.ObjekatID}_${parseInt(beton.BrojNaloga)}_${god}`,
      erpMainOrder: extra.BrojNarudzbeDisp || '',
      mixingTime: spojiVrijeme(beton, dateFn),
      tvrtka: beton.Tvrtka,
      objekat: beton.Objekat,
      kupac: beton.Kupac,
      gradiliste: beton.Gradiliste,
      receptura: beton.Receptura,
      sifraArtikla: beton.SifraArtikla,
      nameFinishedProduct: extra.NazivGotovogProizvoda || '',
      kolicina: parseFloat(beton.Kolicina) || 0,
      povratBetona: parseFloat(beton.PovratBetona) || 0,
      vozac: beton.Vozac,
      regOzn: beton.RegOzn,
      storno: beton.Storno ? t.cancelledValue : ''
    }
    GRUPE.forEach(g => komponentaURed(row, beton, g))
    row.water_target = parseFloat(beton.VodaZadano) || 0
    row.water_dosed = parseFloat(beton.VodaDozirano) || 0
    row.water_added = parseFloat(beton.VodaNaknadno) || 0
    row.water_correction = parseFloat(beton.VodaKorekcija) || 0
    return row
  })
}
